(function($){
	$('.search-trigger a').magnificPopup({
		type: 'inline',
		// modal: true,
		closeOnBgClick: false,
		closeOnContentClick: false,
		showCloseBtn: true,
		closeBtnInside: true,
		enableEscapeKey: false,
		autoFocusLast: false,
		focus: '#search-input',
		mainClass: 'mfp-fade'
	});
})(jQuery);
